import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.LOG_OUT_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.LOG_OUT_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.LOG_OUT_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.LOG_OUT_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.LOG_OUT_RESET_ALL:
            return initialState
		default:
			return state;
	}
};
